var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBottomRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5C5F62",
  fillRule: "evenodd",
  d: "M8.031 21.6h12.737c.459 0 .832-.373.832-.832V8.03a.832.832 0 0 0-1.664 0v11.905H8.031a.832.832 0 0 0 0 1.664",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#5C5F62",
  d: "M14.753 13.479 5.585 4.31a.9.9 0 0 0-1.273 1.273l9.168 9.169-1.909 1.909 5.085-.007.006-5.084z"
})));
export default SvgBottomRight;